import type {ListMaterialFunctionsSearchInput} from "./list-material-functions.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listMaterialFunctionsQueryOptions} from "./list-material-functions.query-options";

export function useListMaterialFunctions(rawInput: ListMaterialFunctionsSearchInput) {
  return useQuery({
    ...listMaterialFunctionsQueryOptions(rawInput),
    placeholderData: keepPreviousData,
  });
}
